import { useNavigate } from "react-router-dom";
import { usePressKit } from "../../../context/PressKitContext";
import { isPressKitEmpty } from "../../../utils/isPressKitEmpty";
import PressKitPreview from "../../../components/pressKitPreview/PressKitPreview";
import ButtonGradient from "../../../components/ui/ButtonGradient";
import WelcomeMessage from "../../../components/welcomeMessage/WelcomeMessage";
import { Container } from "./LoggedHomeStyles";

const LoggedHome = () => {
  const navigate = useNavigate();
  const { pressKitData } = usePressKit();

  const showMock = isPressKitEmpty(pressKitData);

  return (
    <Container>
      <WelcomeMessage />
      <PressKitPreview data={showMock ? undefined : pressKitData} />
      <ButtonGradient onClick={() => navigate("/biography")}>
        Monte seu Portfólio Agora
      </ButtonGradient>
    </Container>
  );
};

export default LoggedHome;
